import styled from '@emotion/styled'

/* ─── Scrim (dark overlay behind modal) ─── */
export const Scrim = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(7, 7, 15, 0.7);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
`

/* ─── Modal shell ─── */
export const ModalContainer = styled.div`
  background: #fbfbfb;
  display: flex;
  flex-direction: column;
  width: 1200px;
  height: 614px;
  border-radius: 3px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.18);
`

/* ─── Header ─── */
export const ModalHeader = styled.div`
  background: #fff;
  border-bottom: 1px solid #e3e5e8;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 25px;
  border-radius: 3px 3px 0 0;
  overflow: hidden;
`

export const ModalTitle = styled.span`
  font-family: Arial, sans-serif;
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  color: rgba(7, 7, 15, 0.87);
`

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(7, 7, 15, 0.4);
  font-size: 18px;
  &:hover {
    color: rgba(7, 7, 15, 0.87);
  }
`

/* ─── Body (main + side) ─── */
export const ModalBody = styled.div`
  display: flex;
  flex: 1;
  min-height: 0;
  overflow: hidden;
`

/* ─── Main content area (left) ─── */
export const MainContent = styled.div`
  flex: 1 0 0;
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  align-self: stretch;
`

export const ContentContainer = styled.div`
  background: #fbfbfb;
  flex: 1 0 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 25px;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
  scrollbar-gutter: stable;
`

export const ExplainerText = styled.div`
  font-family: Arial, sans-serif;
  font-size: 14px;
  line-height: 18px;
  color: rgba(7, 7, 15, 0.87);
  padding-right: 12px;
`

/* ─── Two-card layout ─── */
export const CardContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
  min-width: 0;
`

export const CardColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  min-width: 0;
  flex-shrink: 0;
  flex-basis: 0;
`

export const CardLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const CardLabelIconWrap = styled.div`
  width: 22px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`

export const CardLabelText = styled.span`
  font-family: Arial, sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  color: rgba(7, 7, 15, 0.87);
`

export const VersionCard = styled.div`
  background: #fff;
  border: 1px solid
    ${(props) => (props.isSelected ? '#0051C4' : 'rgba(7, 7, 15, 0.4)')};
  border-radius: 3px;
  display: flex;
  gap: 16px;
  align-items: flex-start;
  padding: 25px;
  min-height: 146px;
  width: 100%;
  box-sizing: border-box;
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  overflow: visible;
`

export const RadioInput = styled.input`
  appearance: auto;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  accent-color: #0051c4;
  opacity: ${(props) => (props.disabled ? 0.4 : 1)};
`

export const RadioWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
  width: 16px;
`

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  min-width: 0;
`

export const CardTitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: Arial, sans-serif;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: #07070f;
  white-space: nowrap;
`

export const FeatureStatus = styled.span`
  font-family: Arial, sans-serif;
  font-size: 12px;
  line-height: 16px;
  color: rgba(7, 7, 15, 0.7);
  & > strong {
    font-weight: 700;
  }
`

export const HelperText = styled.div`
  font-family: Arial, sans-serif;
  font-size: 14px;
  line-height: 18px;
  color: rgba(7, 7, 15, 0.7);
`

export const WhyNotButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: #0b2e6b;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0;
  svg path {
    fill: #0b2e6b;
  }
  &:hover {
    text-decoration: underline;
  }
`

export const WhyNotContent = styled.div`
  font-size: 14px;
  line-height: 18px;
  color: rgba(7, 7, 15, 0.87);
  padding-top: 4px;
  width: 100%;

  p {
    margin: 0;
    white-space: pre-wrap;
  }

  ul {
    list-style-type: disc;
    padding-left: 20px;
    margin: 0;
    font-size: 14px;
    line-height: 18px;
  }

  li {
    margin: 0;
  }
`

/* ─── Side container (right) ─── */
export const SideContainer = styled.div`
  background: #fff;
  border-left: 1px solid #e3e5e8;
  width: 280px;
  flex-shrink: 0;
  overflow-x: hidden;
  overflow-y: auto;
  align-self: stretch;
`

export const SideTab = styled.div`
  display: flex;
  align-items: stretch;
  border-bottom: 1px solid #e3e5e8;
  background: ${(props) => (props.isSelected ? '#F1F2F3' : '#fff')};
  cursor: pointer;
  &:hover {
    background: #f1f2f3;
  }
`

export const SideTabAccent = styled.div`
  width: 6px;
  flex-shrink: 0;
  background: #1e7aff;
  opacity: ${(props) => (props.isSelected ? 1 : 0)};
`

export const SideTabContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 16px 25px;
  min-width: 0;
`

export const SideTabFeatureNumber = styled.span`
  font-family: Arial, sans-serif;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: #07070f;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const SideTabStatusRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
`

export const SideTabStatusText = styled.span`
  flex: 1;
  font-family: Arial, sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  color: rgba(7, 7, 15, 0.7);
  min-width: 0;
`

/* ─── Footer ─── */
export const ModalFooter = styled.div`
  background: #fff;
  border-top: 1px solid #e3e5e8;
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: flex-end;
  padding: 16px 25px;
  border-radius: 0 0 3px 3px;
`

export const FooterButton = styled.button`
  font-family: Arial, sans-serif;
  font-size: 16px;
  line-height: normal;
  padding: 11px 12px;
  border-radius: 3px;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  white-space: nowrap;
  background: ${(props) =>
    props.variant === 'primary'
      ? props.disabled
        ? '#F1F2F3'
        : '#0B2E6B'
      : '#fff'};
  border: 1px solid
    ${(props) =>
      props.variant === 'primary'
        ? props.disabled
          ? '#E3E5E8'
          : '#0B2E6B'
        : '#8C96A2'};
  color: ${(props) =>
    props.variant === 'primary'
      ? props.disabled
        ? 'rgba(7, 7, 15, 0.4)'
        : '#fff'
      : '#0B2E6B'};

  &:hover:not(:disabled) {
    background: ${(props) =>
      props.variant === 'primary' ? '#1E7AFF' : '#f5f5f5'};
    border-color: ${(props) =>
      props.variant === 'primary' ? '#1E7AFF' : '#8C96A2'};
  }

  &:focus:not(:disabled) {
    background: ${(props) =>
      props.variant === 'primary' ? '#0051C4' : '#f5f5f5'};
    border-color: ${(props) =>
      props.variant === 'primary' ? '#0051C4' : '#8C96A2'};
  }
`
